export default __webpack_public_path__ + "static/media/Kriti and Kai_Johnsons Locust Hall Farm_AS Nagpal_5_tn.6b3491a2.jpg";